import {useRefetchOnAliveUpdate} from './use-refetch-on-alive-update'
import {useHeaderPageData} from '../page-data/loaders/use-header-page-data'
import type {AliveChannels} from '../page-data/payloads/header'

type HeaderLiveUpdateChannels = {
  pullRequest: AliveChannels['pullRequest']
  pullRequestState: AliveChannels['pullRequestState']
}

export function useHeaderLiveUpdates({pullRequest, pullRequestState}: HeaderLiveUpdateChannels): void {
  const {refetch} = useHeaderPageData()
  useRefetchOnAliveUpdate(pullRequest, refetch, {git_updated: true, title_updated: true})
  useRefetchOnAliveUpdate(pullRequestState, refetch)
}
